import { Script } from '../Script';
import { component$ } from '@builder.io/qwik';

export const GTMScript = component$(() => (
  <>
    <Script
      dangerouslySetInnerHTML={`
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${global.ENV.PUBLIC_GTM_KEY}');
      `}
      strategy="userInteraction"
    />
    <noscript>
      <iframe
        style={{ display: 'none', visibility: 'hidden' }}
        width="0"
        height="0"
        src={`https://www.googletagmanager.com/ns.html?id=${global.ENV.PUBLIC_GTM_KEY}`}
      />
    </noscript>
  </>
));
